import { pdfjs } from "react-pdf";

import { useEffect, useState } from "react";

// A simpler approach that avoids most race conditions
const PdfViewer = ({ fileData }) => {
  const [pdfPages, setPdfPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Set the worker source
    pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.mjs`;

    // Initialize flag to track component mounted state
    let isMounted = true;
    setLoading(true);
    setError(null);
    setPdfPages([]);

    // Function to load and render PDF
    const loadPdf = async () => {
      try {
        // Safety check - if no data or component unmounted, exit
        if (!fileData || !isMounted) return;

        // Load the PDF document
        const loadingTask = pdfjs.getDocument({ data: fileData });
        const pdf = await loadingTask.promise;

        if (!isMounted) return;

        // Pre-render all pages to data URLs
        const pageDataUrls = [];
        const numPages = pdf.numPages;

        for (let pageNum = 1; pageNum <= numPages; pageNum++) {
          // Check if component still mounted before continuing
          if (!isMounted) return;

          const page = await pdf.getPage(pageNum);

          // If unmounted during page load, stop processing
          if (!isMounted) return;

          const viewport = page.getViewport({ scale: 1.5 });
          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          // Render page to canvas
          await page.render({
            canvasContext: canvas.getContext("2d"),
            viewport: viewport,
          }).promise;

          if (!isMounted) return;

          // Convert canvas to data URL
          const dataUrl = canvas.toDataURL("image/png");
          pageDataUrls.push({
            pageNumber: pageNum,
            dataUrl,
            width: viewport.width,
            height: viewport.height,
          });
        }

        if (isMounted) {
          setPdfPages(pageDataUrls);
          setLoading(false);
        }
      } catch (err) {
        console.error("Error processing PDF:", err);
        if (isMounted) {
          setError("Failed to load PDF");
          setLoading(false);
        }
      }
    };

    // Start loading process
    loadPdf();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [fileData]);

  if (loading) {
    return (
      <div className="pdf-container">
        <div className="pdf-loading">Loading PDF...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pdf-container">
        <div className="pdf-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="pdf-container">
      <div className="pdf-pages">
        {pdfPages.map((page) => (
          <div key={`page-${page.pageNumber}`} className="pdf-page">
            <img
              src={page.dataUrl}
              alt={`Page ${page.pageNumber}`}
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PdfViewer;
